module.exports = __webpack_public_path__ + "static/media/edit.4b610a5e.svg";